import React from 'react';
import { Dimensions, Platform, Text, View, ViewPropTypes } from 'react-native'

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { VFButton, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { Images } from '../../../Themes';
import PaymentMethod from '../PaymentMethod';

import styles from './PaymentFooter.Styles';

import { isNil as _isNil } from 'lodash'

const PaymentFooter = ({
  titleAndIconContainerStyle,
  title,
  titleStyle,
  icon,
  iconStyle,
  btnsContainerStyle,
  btnSuccessType,
  btnSuccessTitle,
  btnSuccessTextStyle,
  btnSuccessStyle,
  isBtnSuccessDisabled,
  successBtnDisabledStyle,
  successBtnDisabledTextStyle,
  successBtnTheme,
  btnRejectType,
  btnRejectTitle,
  btnRejectTextStyle,
  btnRejectStyle,
  hasMoreBtns,
  isPaymentMethod,
  description,
  descriptionStyle,
  upgradingPayment,
  onSuccessBtnPress,
  onRejectBtnPress,
  btnSuccessPlaceHolders,
  btnRejectPlaceHolders,
  successBtnID,
  rejectBtnID,
  paymentMethodAccessibilityLabel,
  paymentEditIconAccessibilityLabel,
  paymentVisaInfoAccessibilityLabel,
  defaultPayment,
  paymentCards,
  onAddCard,
  onOpenCardList,
  isCardListOpend,
  onSelectDefaultCard,
  renderExtraCard,
  theme,
  renderCustomPaymentMethod,
  isVoucherTopUp,
  voucherBtnContainerStyle,
  isValidTopupNumber,
  ...props
}) => {
  const isEmptyCardsList = _.isEmpty(paymentCards);

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={styles.footerContainer} testID="topUpPaymentFooter">
        <PaymentMethod
          titleAndIconContainerStyle={titleAndIconContainerStyle}
          title={title}
          titleStyle={titleStyle}
          icon={icon}
          iconStyle={iconStyle}
          paymentMethodAccessibilityLabel={paymentMethodAccessibilityLabel}
          paymentEditIconAccessibilityLabel={
            paymentEditIconAccessibilityLabel
          }
          defaultPayment={defaultPayment}
          paymentCards={paymentCards}
          onAddCard={onAddCard}
          onOpenCardList={onOpenCardList}
          isCardListOpend={isCardListOpend}
          onSelectDefaultCard={onSelectDefaultCard}
          renderExtraCard={renderExtraCard}
          isValidTopupNumber={isValidTopupNumber}
        />

        {!_isNil(description) && (
          <VFText i18nKey={description} style={descriptionStyle} />
        )}
        <View style={[styles.btnsContainer, btnsContainerStyle]}>
          <VFButton
            title={btnSuccessTitle}
            placeHolders={btnSuccessPlaceHolders}
            type={btnSuccessType}
            style={[styles.btnSuccess, btnSuccessStyle]}
            onPress={() => onSuccessBtnPress()}
            disabledStyle={[
              styles.successBtnDisabled(theme),
              successBtnDisabledStyle
            ]}
            disabledTextStyle={[
              styles.successBtnDisabledText(theme),
              successBtnDisabledTextStyle
            ]}
            forceTheme={successBtnTheme}
            textStyle={btnSuccessTextStyle}
            disabled={
              isBtnSuccessDisabled || (isPaymentMethod && isEmptyCardsList)
            }
            testID={successBtnID}
          />
          {hasMoreBtns && (
            <VFButton
              title={btnRejectTitle}
              placeHolders={btnRejectPlaceHolders}
              type={btnRejectType}
              style={[styles.btnReject(theme), btnRejectStyle]}
              onPress={() => onRejectBtnPress()}
              textStyle={btnRejectTextStyle}
              testID={rejectBtnID}
            />
          )}
        </View>
      </View>
    )
  }
  return (
    <View
      style={styles.footerContainer(isVoucherTopUp)}
      testID={FrameworkTestKeys.TopUpPaymentFooter}
    >
      {_.isFunction(renderCustomPaymentMethod)
        ? renderCustomPaymentMethod()
        : isPaymentMethod && (
          <PaymentMethod
            titleAndIconContainerStyle={titleAndIconContainerStyle}
            title={title}
            titleStyle={titleStyle}
            icon={icon}
            iconStyle={iconStyle}
            paymentMethodAccessibilityLabel={paymentMethodAccessibilityLabel}
            paymentEditIconAccessibilityLabel={paymentEditIconAccessibilityLabel}
            defaultPayment={defaultPayment}
            paymentCards={paymentCards}
            onAddCard={onAddCard}
            onOpenCardList={onOpenCardList}
            isCardListOpend={isCardListOpend}
            onSelectDefaultCard={onSelectDefaultCard}
            renderExtraCard={renderExtraCard}
          />
        )}

      <View style={styles.widthAdjustment}>
        {!_.isNil(description) && (
          <VFText type="primary" i18nKey={description} style={descriptionStyle} />
        )}
        <View
          style={
            isVoucherTopUp
              ? [styles.btnsContainer, btnsContainerStyle, voucherBtnContainerStyle, { width: '90%' }]
              : [styles.btnsContainer, btnsContainerStyle]
          }
        >
          <VFButton
            title={btnSuccessTitle}
            placeHolders={btnSuccessPlaceHolders}
            type={btnSuccessType}
            style={[styles.btnSuccess, btnSuccessStyle]}
            onPress={() => _.isFunction(onSuccessBtnPress) && onSuccessBtnPress()}
            disabledStyle={[styles.successBtnDisabled(theme), successBtnDisabledStyle]}
            disabledTextStyle={[styles.successBtnDisabledText(theme), successBtnDisabledTextStyle]}
            forceTheme={successBtnTheme}
            textStyle={btnSuccessTextStyle}
            disabled={isBtnSuccessDisabled || (isPaymentMethod && isEmptyCardsList)}
            testID={successBtnID}
          />
          {hasMoreBtns && (
            <VFButton
              title={btnRejectTitle}
              placeHolders={btnRejectPlaceHolders}
              type={btnRejectType}
              style={[styles.btnReject(theme), btnRejectStyle]}
              onPress={() => onRejectBtnPress()}
              textStyle={btnRejectTextStyle}
              testID={rejectBtnID}
            />
          )}
        </View>
      </View>
    </View>
  );
};

PaymentFooter.defaultProps = {
  title: 'top_up_quick_action_payment_method_title',
  btnSuccessType: 'primary',
  btnRejectType: 'secondary',
  successBtnTheme: {
    force: true,
  },
  icon: Images.edit_pen,
  theme: LightThemeColors,
};

PaymentFooter.propTypes = {
  titleAndIconContainerStyle: ViewPropTypes.style,
  title: PropTypes.string,
  titleStyle: ViewPropTypes.style,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconStyle: ViewPropTypes.style,
  btnsContainerStyle: ViewPropTypes.style,
  btnSuccessType: PropTypes.string,
  btnSuccessTextStyle: TextPropTypes.style,
  btnSuccessStyle: ViewPropTypes.style,
  isBtnSuccessDisabled: PropTypes.bool,
  successBtnDisabledStyle: ViewPropTypes.style,
  successBtnDisabledTextStyle: TextPropTypes.style,
  successBtnTheme: PropTypes.shape({
    force: PropTypes.bool,
  }),
  btnRejectType: PropTypes.string,
  btnRejectTextStyle: TextPropTypes.style,
  btnRejectStyle: ViewPropTypes.style,
  description: PropTypes.string,
  descriptionStyle: TextPropTypes.style,
  btnSuccessTitle: PropTypes.string,
  btnRejectTitle: PropTypes.string,
  hasMoreBtns: PropTypes.bool,
  isPaymentMethod: PropTypes.bool,
  upgradingPayment: PropTypes.bool,
  onSuccessBtnPress: PropTypes.func,
  onRejectBtnPress: PropTypes.func,
  btnSuccessPlaceHolders: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number])),
    PropTypes.string,
  ]),
  btnRejectPlaceHolders: PropTypes.arrayOf(PropTypes.string),
  successBtnID: PropTypes.string,
  rejectBtnID: PropTypes.string,
  paymentMethodAccessibilityLabel: PropTypes.string,
  paymentEditIconAccessibilityLabel: PropTypes.string,
  paymentVisaInfoAccessibilityLabel: PropTypes.string,
  defaultPayment: PropTypes.object,
  paymentCards: PropTypes.array,
  onAddCard: PropTypes.func,
  onOpenCardList: PropTypes.func,
  onSelectDefaultCard: PropTypes.func,
  isCardListOpend: PropTypes.bool,
  renderExtraCard: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  renderCustomPaymentMethod: PropTypes.func,
  isVoucherTopUp: PropTypes.bool,
  voucherBtnContainerStyle: PropTypes.object,
};
export default withTheme(PaymentFooter);
